import React from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import imageUrl from "../images/studentsforpope.jpg";

const StudentsForPopeJoin = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));



  return (
    <Box sx={{ backgroundColor: "#1d2845", minHeight: "60vh", py: 12, px: 2 }}>
      <Box
        sx={{
          maxWidth: isMobile ? "100%" : 900,
          margin: "0 auto",
          textAlign: "center",
          color: "white",
        }}
      >

        <Box sx={{ mb: 3 }}>
          <img
            src={imageUrl}
            alt="Students for Pope flyer"
            style={{ width: "100%", height: "auto", borderRadius: 8 }}
          />
        </Box>

        <Typography variant="body1" sx={{ mb: 1 }}>
          click here to join:
        </Typography>

        <Button
          variant="contained"
          href="#"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ background: "#00853e!important", textTransform: "none" }}
        >
          Need form
        </Button>
      </Box>
    </Box>
  );
};

export default StudentsForPopeJoin;
